import React, {ReactNode, useCallback} from "react";

import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";
import {IUserPhoneVerificationContextValue, UserPhoneVerificationContext} from "@pg-mono/user";

import {HOTLINE_INFO_PHONE_NUMBER} from "../../hotline/constants/hotline_phone_numbers";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch} from "../../store/hooks";
import {useGetUserProfileQuery} from "../api/get_user_profile";
import {usePostUserPhoneVerificationCodeMutation} from "../api/post_user_phone_verification_code";
import {usePostUserPhoneVerifyMutation} from "../api/post_user_phone_verify";
import {apiErrorHandler} from "../hooks/use_api_error_handler";
import {IAmplitudePhoneVerificationContext, trackAmplitudePhoneVerified} from "../tracking/track_amplitude_phone_verified";

interface IProps {
    children: ReactNode;
    amplitudeContext?: IAmplitudePhoneVerificationContext;
}

export const UserPhoneVerificationProvider = (props: IProps) => {
    const {children, amplitudeContext} = props;
    const dispatch = useAppDispatch();
    const {data: userInfo} = useGetUserProfileQuery();
    const [sendPhoneVerificationCode] = usePostUserPhoneVerificationCodeMutation();
    const [postUserPhoneVerify] = usePostUserPhoneVerifyMutation();

    const getUserProfile = useCallback(async () => {
        if (!userInfo) {
            return null;
        }
        return userInfo;
    }, [userInfo]);

    const handleSendPhoneVerificationCode = useCallback(async () => {
        const response = await sendPhoneVerificationCode();

        if (isFetchBaseQueryError(response.error)) {
            const error = response.error;
            const errorResult = apiErrorHandler(error);
            if (errorResult) {
                return {error: errorResult};
            } else {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
                return {error: {message: "Wystąpił błąd podczas wysyłania kodu", status: 500}};
            }
        }

        return {};
    }, [sendPhoneVerificationCode, dispatch]);

    const handleVerifyPhone = useCallback(
        async (code: string) => {
            const response = await postUserPhoneVerify({verification_code: code});

            if (isFetchBaseQueryError(response.error)) {
                trackAmplitudePhoneVerified(false, amplitudeContext);

                const error = response.error;
                const errorResult = apiErrorHandler(error);
                if (errorResult) {
                    return {error: errorResult};
                } else {
                    dispatch(addNotification({notification: defaultAPIErrorNotification}));
                    return {error: {message: "Wystąpił błąd podczas weryfikacji", status: 500}};
                }
            }

            trackAmplitudePhoneVerified(true, amplitudeContext);

            return {};
        },
        [postUserPhoneVerify, dispatch, amplitudeContext]
    );

    const contextValue: IUserPhoneVerificationContextValue = {
        getUserProfile,
        sendPhoneVerificationCode: handleSendPhoneVerificationCode,
        verifyPhone: handleVerifyPhone,
        hotlinePhoneNumber: HOTLINE_INFO_PHONE_NUMBER
    };

    return <UserPhoneVerificationContext.Provider value={contextValue}>{children}</UserPhoneVerificationContext.Provider>;
};
import React, {ReactNode, useCallback} from "react";

import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";
import {IUserPhoneVerificationContextValue, UserPhoneVerificationContext} from "@pg-mono/user";

import {HOTLINE_INFO_PHONE_NUMBER} from "../../hotline/constants/hotline_phone_numbers";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch} from "../../store/hooks";
import {useGetUserProfileQuery} from "../api/get_user_profile";
import {usePostUserPhoneVerificationCodeMutation} from "../api/post_user_phone_verification_code";
import {usePostUserPhoneVerifyMutation} from "../api/post_user_phone_verify";
import {apiErrorHandler} from "../hooks/use_api_error_handler";
import {IAmplitudePhoneVerificationContext, trackAmplitudePhoneVerified} from "../tracking/track_amplitude_phone_verified";

interface IProps {
    children: ReactNode;
    amplitudeContext?: IAmplitudePhoneVerificationContext;
}

export const UserPhoneVerificationProvider = (props: IProps) => {
    const {children, amplitudeContext} = props;
    const dispatch = useAppDispatch();
    const {data: userInfo} = useGetUserProfileQuery();
    const [sendPhoneVerificationCode] = usePostUserPhoneVerificationCodeMutation();
    const [postUserPhoneVerify] = usePostUserPhoneVerifyMutation();

    const getUserProfile = useCallback(async () => {
        if (!userInfo) {
            return null;
        }
        return userInfo;
    }, [userInfo]);

    const handleSendPhoneVerificationCode = useCallback(async () => {
        const response = await sendPhoneVerificationCode();

        if (isFetchBaseQueryError(response.error)) {
            const error = response.error;
            const errorResult = apiErrorHandler(error);
            if (errorResult) {
                return {error: errorResult};
            } else {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
                return {error: {message: "Wystąpił błąd podczas wysyłania kodu", status: 500}};
            }
        }

        return {};
    }, [sendPhoneVerificationCode, dispatch]);

    const handleVerifyPhone = useCallback(
        async (code: string) => {
            const response = await postUserPhoneVerify({verification_code: code});

            if (isFetchBaseQueryError(response.error)) {
                trackAmplitudePhoneVerified(false, amplitudeContext);

                const error = response.error;
                const errorResult = apiErrorHandler(error);
                if (errorResult) {
                    return {error: errorResult};
                } else {
                    dispatch(addNotification({notification: defaultAPIErrorNotification}));
                    return {error: {message: "Wystąpił błąd podczas weryfikacji", status: 500}};
                }
            }

            trackAmplitudePhoneVerified(true, amplitudeContext);

            return {};
        },
        [postUserPhoneVerify, dispatch, amplitudeContext]
    );

    const contextValue: IUserPhoneVerificationContextValue = {
        getUserProfile,
        sendPhoneVerificationCode: handleSendPhoneVerificationCode,
        verifyPhone: handleVerifyPhone,
        hotlinePhoneNumber: HOTLINE_INFO_PHONE_NUMBER
    };

    return <UserPhoneVerificationContext.Provider value={contextValue}>{children}</UserPhoneVerificationContext.Provider>;
};
